import { PwCheckIcon } from '@components/Icons/PwCheckIcon';
import { Box } from '@mui/material';
import classNames from 'classnames';
import css from './PasswordValidationComponent.module.scss';

interface PasswordValidationProps {
  passwordValidation: Array<{
    satisfied: boolean;
    message: string;
  }>;
}

export const PasswordValidationComponent = ({ passwordValidation }: PasswordValidationProps) => {
  return (
    <Box className={css.passwordConditionsContainer}>
      {passwordValidation.map((condition) => (
        <Box
          key={condition.message}
          className={classNames(
            css.passwordConditionContainerInner,
            condition.satisfied && css.passwordConditionIconSatisfied,
            !condition.satisfied && css.passwordConditionIconNotSatisfied,
          )}
        >
          <Box className={classNames(css.passwordConditionIcon)}>
            {condition.satisfied ? (
              <PwCheckIcon />
            ) : (
              <span className={css.passwordConditionIconNotSatisfied}>⚬</span>
            )}
          </Box>
          <Box className={classNames(css.passwordCondition)}>{condition.message}</Box>
        </Box>
      ))}
    </Box>
  );
};
